import { z } from 'zod';

const deskDayRowSchema = z.object({
  id: z.string(),
  customerName: z.string(),
  vehicleName: z.string(),
  status: z.string(),
  pickupDate: z.string(),
  dropoffDate: z.string(),
  pickupTime: z.string(),
  dropoffTime: z.string(),
  pickupLocation: z.string(),
  dropoffLocation: z.string(),
  amountDue: z.coerce.number(),
});

const deskDayListSchema = z.object({
  count: z.number().int(),
  rows: z.array(deskDayRowSchema),
});

export const deskDaySchema = z.object({
  date: z.string(),
  pickups: deskDayListSchema,
  returns: deskDayListSchema,
  overdue: deskDayListSchema,
  unpaid: deskDayListSchema,
});

export type DeskDayRow = z.infer<typeof deskDayRowSchema>;
export type DeskDayList = z.infer<typeof deskDayListSchema>;
export type DeskDayBoard = z.infer<typeof deskDaySchema>;

export function deskDayRows(list: DeskDayList, needle: string): DeskDayRow[] {
  const query = needle.trim().toLowerCase();
  if (query === '') return list.rows;
  return list.rows.filter((row) =>
    `${row.id} ${row.customerName} ${row.vehicleName} ${row.pickupLocation} ${row.dropoffLocation}`
      .toLowerCase()
      .includes(query),
  );
}
